import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Lock, EyeOff, ImageIcon } from 'lucide-react';

export const DashboardModals = ({
  showWhatsAppLock, setShowWhatsAppLock,
  viewingPhoto, setViewingPhoto,
  showArchiveLock, setShowArchiveLock
}) => (
  <>
    {/* WhatsApp Lock Modal */}
    <Dialog open={showWhatsAppLock} onOpenChange={setShowWhatsAppLock}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-2">
            <div className="w-14 h-14 rounded-full bg-[#0A2647] flex items-center justify-center">
              <Lock className="w-6 h-6 text-[#C5A059]" />
            </div>
          </div>
          <DialogTitle className="text-center text-lg">Recurso Exclusivo para Assinantes</DialogTitle>
          <DialogDescription className="text-center text-sm leading-relaxed pt-2">
            Este recurso e dinamico e exclusivo para assinantes. Faca o upgrade agora para falar com seu cliente no zap!
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 sm:flex-col pt-2">
          <Link to="/checkout/pro" className="w-full">
            <Button className="w-full h-11 bg-[#C5A059] hover:bg-[#d4af61] text-[#0A2647] font-bold rounded-xl" data-testid="whatsapp-upgrade-btn">
              Assinar Plano Profissional — R$ 39,90/mes
            </Button>
          </Link>
          <Button variant="ghost" className="w-full text-sm text-slate-500" onClick={() => setShowWhatsAppLock(false)} data-testid="whatsapp-lock-close">
            Agora não
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>

    {/* Photo Viewer Modal */}
    <Dialog open={!!viewingPhoto} onOpenChange={(open) => !open && setViewingPhoto(null)}>
      <DialogContent className="sm:max-w-2xl p-2" data-testid="photo-viewer-modal">
        <DialogHeader className="px-4 pt-3 pb-1">
          <DialogTitle className="text-base flex items-center gap-2">
            <ImageIcon className="w-5 h-5 text-[#C5A059]" />
            Foto Anexada pelo Cliente
          </DialogTitle>
        </DialogHeader>
        <div className="w-full flex items-center justify-center bg-slate-100 rounded-lg overflow-hidden min-h-[200px]">
          {viewingPhoto && (
            <img src={viewingPhoto} alt="Foto do feedback" className="max-w-full max-h-[70vh] object-contain" data-testid="photo-viewer-img" />
          )}
        </div>
      </DialogContent>
    </Dialog>

    {/* Archive Lock Modal */}
    <Dialog open={showArchiveLock} onOpenChange={setShowArchiveLock}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-2">
            <div className="w-14 h-14 rounded-full bg-[#0A2647] flex items-center justify-center">
              <EyeOff className="w-6 h-6 text-[#C5A059]" />
            </div>
          </div>
          <DialogTitle className="text-center text-lg">Ocultar Avaliacoes</DialogTitle>
          <DialogDescription className="text-center text-sm leading-relaxed pt-2">
            O recurso de ocultar avaliacoes e exclusivo para planos <strong>Empresarial</strong>, <strong>Elite</strong> e <strong>5 Estrelas</strong>. Faca upgrade para ter controle total sobre quais avaliacoes ficam visiveis no seu painel.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 sm:flex-col pt-2">
          <Link to="/checkout/enterprise" className="w-full">
            <Button className="w-full h-11 bg-[#C5A059] hover:bg-[#d4af61] text-[#0A2647] font-bold rounded-xl" data-testid="archive-upgrade-btn">
              Assinar Empresarial — R$ 59,90/mes
            </Button>
          </Link>
          <Button variant="ghost" className="w-full text-sm text-slate-500" onClick={() => setShowArchiveLock(false)} data-testid="archive-lock-close">
            Agora não
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>
);
